export default __webpack_public_path__ + "static/AeonikBold-7999becabfc22767b5f82e71ecff606f.otf";